import { Box, Link, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_REC015 } from "./api/request";
import { headList, searchFormList, searchFormSchema } from "./parts";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import { BillingDepositList } from "../../type/apiType/IAPI_REC015";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import _ from "lodash";
import { PaymentStatus } from "../../assets/data/Constants";
import dayjs from "dayjs";

/**
 * SCRW160003 共済契約者ホーム
 * @return SCRW160003 共済契約者ホーム
 */
const SCRW160003 = () => {
  const navigate = useNavigate();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.paymentManagement?.searchForBilling;
  const { state, setState } = useContext(GlobalContext);
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [listData, setListData] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const [date, setDate] = useState<any>({});
  const dateValid = {
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
  };

  useEffect(() => {
    let resArr = searchList.current;
    resArr.find((item: any) => item.keyword === "searchKbn")!.wantToSetValue =
      context?.searchKbn;
    resArr.find(
      (item: any) => item.keyword === "searchBillingContractor"
    )!.wantToSetValue = context?.searchBillingContractor;
    resArr.find(
      (item: any) => item.keyword === "searchReceiveStatus"
    )!.wantToSetValue = context
      ? context?.searchReceiveStatus
      : PaymentStatus["入金待ち"];
    setStateSearchList([...resArr]);

    if (context) {
      handleSearch(context);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatData = (data?: BillingDepositList[], search?: any) => {
    const gotoDetail = (id?: number) => {
      setBusinessState({
        ...businessState,
        job_13: { ...businessState.job_13, demanderId: id },
        paymentManagement: {
          searchForBilling: search,
        },
      });
      navigate("/SCRW160005");
    };

    return data?.map((item) => {
      let receiveStatus = item.receiveStatus;
      if (receiveStatus === "請求中" || receiveStatus === "一部入金") {
        receiveStatus = "入金待ち";
      }
      return [
        {
          children: (
            <Link
              onClick={() => gotoDetail(item.invoiceId)}
              data-testid="SCRW160003LinkTest"
            >
              {item.invoiceId}
            </Link>
          ),
          forSort: item.invoiceId,
        },
        {
          children: item.billingDate,
          forSort: item.billingDate,
        },
        {
          children: item.billingContractorName,
          forSort: item.billingContractorName,
        },
        {
          children: item.invoiceKbn,
          forSort: item.invoiceKbn,
        },
        {
          children: changeAmountFormat(item.billingAmt ?? 0),
          forSort: item.billingAmt,
          align: "right",
        },
        {
          children: item.billingStatus,
          forSort: item.billingStatus,
        },
        {
          children: receiveStatus,
          forSort: receiveStatus,
        },
        {
          children: changeAmountFormat(item.depositAmt ?? 0),
          forSort: item.depositAmt,
          align: "right",
        },
      ];
    });
  };

  const handleDateChange = (field: any) => (event: any) => {
    const date = event.target.value;
    const value =
      date === "Invalid Date" ||
      dayjs(date).isBefore(dayjs(dateValid.minDate)) ||
      dayjs(date).isAfter(dayjs(dateValid.maxDate))
        ? "Invalid Date"
        : date;

    setDate((prevDate: any) => ({
      ...prevDate,
      [field]: value,
    }));
  };

  // 検索
  const handleSearch = async (data: any) => {
    let param = {
      billingDateFrom: date.billingDateFrom,
      billingDateTo: date.billingDateTo,
      ...data,
    };
    if (Object.values(param).some((i) => i === "Invalid Date")) return;

    // 請求・収納一覧参照API 呼び出し
    try {
      const res = await httpAPI_REC015({
        ...param,
      });

      if (res.resultCd === "I0000") {
        let billingDepositList = res.billingDepositList;

        setListData(billingDepositList ?? []);
        setBodyList(formatData(billingDepositList, param));
        setBusinessState({
          ...businessState,
          paymentManagement: {
            searchForBilling: param,
          },
        });
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleGoToPage = () => {
    navigate("/SCRW160004");
  };

  return (
    <Box className="SCRW160003" data-testid="SCRW160003PageForTest">
      <Box className="searchArea">
        <TkSearchForm
          listData={stateSearchList}
          ruleSchema={searchFormSchema}
          onSearch={handleSearch}
        />
        <Box className="dateInputArea">
          <Box className="dateInput">
            <Typography className="tkItem">請求日：</Typography>
            <TkDatePicker
              onChange={handleDateChange("billingDateFrom")}
              wantToSetValue={context?.billingDateFrom}
              {...dateValid}
            />
            <Typography> ～ </Typography>
            <TkDatePicker
              onChange={handleDateChange("billingDateTo")}
              wantToSetValue={context?.billingDateTo}
              {...dateValid}
            />
          </Box>
          <Typography>対象件数：{listData?.length}件</Typography>
        </Box>
      </Box>

      <TkDataTable headList={headList} bodyList={bodyList} pagin showUnit />

      <Box className="btnGroup">
        <TkBackButton />
        <TkButton onClick={handleGoToPage}>都道府県補助金請求</TkButton>
      </Box>
    </Box>
  );
};

export default SCRW160003;
